import { apiClient } from './api-client';

// 백엔드 MyCompanyResponse(compCd, compName) 대응.
export interface MyCompany {
  compCd: string;
  compName: string | null;
}

/**
 * 현재 로그인 사용자가 소속된 회사 목록을 조회한다.
 * 응답은 공통 엔벨로프(PetrohqApiResponse)의 result 필드에 담겨 온다.
 */
export async function fetchMyCompanies(): Promise<MyCompany[]> {
  const res = await apiClient
    .get('admin/user/me/companies')
    .json<{ result?: MyCompany[] }>();
  return res.result ?? [];
}
